import {
  TruckIcon,
  MapPinIcon,
  ArrowsRightLeftIcon,
} from "@heroicons/react/20/solid";

/**
 * Customer-facing pill that tells the customer how a service is delivered, shown
 * on the service card during browsing. Themed (respects the provider's brand) —
 * NOT the admin AppointmentTypeBadge, which uses fixed signal colors.
 *
 * `mode` must be the EFFECTIVE, provider-narrowed delivery mode (see
 * getEffectiveDeliveryMode in bookingFlowUtils) — never the raw
 * service.deliveryType. A `null` mode (service not currently bookable in any
 * mode) renders nothing.
 *
 * @param {"mobile" | "fixed" | "hybrid" | null} mode
 */
const MODE_CONFIG = {
  mobile: { Icon: TruckIcon, label: "We come to you" },
  fixed: { Icon: MapPinIcon, label: "Visit us" },
  hybrid: { Icon: ArrowsRightLeftIcon, label: "Mobile or visit us" },
};

const ServiceDeliveryBadge = ({ mode }) => {
  const config = MODE_CONFIG[mode];
  if (!config) return null;

  const { Icon, label } = config;

  return (
    <span
      data-mode={mode}
      className="inline-flex items-center gap-x-1 rounded-pill border border-themed bg-themed-card-elevated px-2 py-0.5 text-xs font-medium text-themed-secondary"
    >
      <Icon className="size-3.5" aria-hidden="true" />
      {label}
    </span>
  );
};

export default ServiceDeliveryBadge;
